import React from "react";
import { Box, Skeleton } from "@mui/material";
import { EventAvailable, CalendarMonth, Groups } from "@mui/icons-material";
import HubMedOverviewStatCard from "@/components/admin/hubmed/HubMedOverviewStatCard";

const HubMedAdminSummaryCards = ({
  totalAppointmentsInRange,
  averageAppointmentsPerWeek,
  activeChemistsCount,
  loading,
}) => {
  const total = totalAppointmentsInRange ?? 0;
  const avgWeek = Number(averageAppointmentsPerWeek ?? 0).toFixed(2);
  const chemists = Number(activeChemistsCount ?? 0);

  if (loading) {
    return (
      <>
        {[1, 2, 3].map((k) => (
          <div key={k} className="min-w-0 h-full flex">
            <Skeleton
              variant="rounded"
              sx={{ borderRadius: 2, width: "100%", minHeight: 112, flex: 1 }}
            />
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      <Box className="min-w-0 h-full flex">
        <HubMedOverviewStatCard
          title="Total appointments"
          value={total}
          valueFormatter={(v) => Number(v || 0).toLocaleString()}
          Icon={EventAvailable}
        />
      </Box>
      <Box className="min-w-0 h-full flex">
        <HubMedOverviewStatCard
          title="Appointments per week"
          value={avgWeek}
          valueFormatter={(v) => v}
          Icon={CalendarMonth}
        />
      </Box>
      <Box className="min-w-0 h-full flex">
        <HubMedOverviewStatCard
          title="Total active chemists"
          value={chemists}
          valueFormatter={(v) => Number(v || 0).toLocaleString()}
          Icon={Groups}
        />
      </Box>
    </>
  );
};

export default HubMedAdminSummaryCards;
